import { jsx, jsxs } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
var Card = ({ className: i,...a }) => /* @__PURE__ */ jsx("div", {
	"data-slot": "card",
	className: twMerge("group/card flex flex-col gap-(--gutter) rounded-lg border py-(--gutter) text-fg shadow-xs [--gutter:--spacing(6)] has-[table]:overflow-hidden has-[table]:not-has-data-[slot=card-footer]:pb-0 **:data-[slot=table-header]:bg-muted/50 has-[table]:**:data-[slot=card-footer]:border-t **:[table]:overflow-hidden", i),
	...a,
	dir: "auto"
}), CardHeader = ({ className: a, title: o, description: s, children: c,...l }) => /* @__PURE__ */ jsxs("div", {
	"data-slot": "card-header",
	className: twMerge("grid auto-rows-min grid-rows-[auto_auto] items-start gap-1 px-(--gutter) has-data-[slot=card-action]:grid-cols-[1fr_auto]", a),
	...l,
	children: [
		o && /* @__PURE__ */ jsx(CardTitle, { children: o }),
		s && /* @__PURE__ */ jsx(CardDescription, { children: s }),
		!o && typeof c == "string" ? /* @__PURE__ */ jsx(CardTitle, { children: c }) : c
	]
}), CardTitle = ({ className: i,...a }) => /* @__PURE__ */ jsx("div", {
	"data-slot": "card-title",
	className: twMerge("text-balance font-semibold text-base/6", i),
	...a
}), CardDescription = ({ className: i,...a }) => /* @__PURE__ */ jsx("div", {
	...a,
	"data-slot": "card-description",
	className: twMerge("row-start-2 text-pretty text-muted-fg text-sm/6", i),
	...a
}), CardAction = ({ className: i,...a }) => /* @__PURE__ */ jsx("div", {
	"data-slot": "card-action",
	className: twMerge("col-start-2 row-span-2 row-start-1 self-start justify-self-end", i),
	...a
}), CardContent = ({ className: i,...a }) => /* @__PURE__ */ jsx("div", {
	"data-slot": "card-content",
	className: twMerge("px-(--gutter) has-[table]:border-t", i),
	...a
}), CardFooter = ({ className: i,...a }) => /* @__PURE__ */ jsx("div", {
	"data-slot": "card-footer",
	className: twMerge("flex items-center px-(--gutter) group-has-[table]/card:pt-(--gutter) [.border-t]:pt-6", i),
	...a
});
export { Card, CardAction, CardContent, CardDescription, CardFooter, CardHeader, CardTitle };
